import React from "react";
import EChartsCanvas from "./EChartsCanvas";

const getRenderSignature = (renderModel) => {
  const optionJson =
    typeof renderModel?.OptionJson === "string"
      ? renderModel.OptionJson
      : JSON.stringify(renderModel?.OptionJson ?? "");

  return [
    renderModel?.Theme ?? "",
    renderModel?.Renderer ?? "",
    renderModel?.DevicePixelRatio ?? "",
    optionJson,
  ].join("|");
};

export default function RealtimeVisualChart({
  runtime,
  chartKey = "realtime-chart",
  style = { width: "100%", height: "100%" },
}) {
  const renderSignature = getRenderSignature(runtime?.renderModel);

  return (
    <EChartsCanvas
      key={`${chartKey}-${renderSignature}`}
      renderModel={runtime?.renderModel}
      isLoading={runtime?.isLoading}
      status={runtime?.status}
      error={runtime?.error}
      style={style}
    />
  );
}
